import { useSyncExternalStore } from "react";
import { personStore } from "@/services/client";
import { EmptyState, SectionHead } from "@/features/shell/EmptyState";

const NO_DESCRIPTION = "No description.";

/** The people in your life, as recorded on the sync feed. */
export function PeoplePage() {
  const people = useSyncExternalStore(personStore.subscribe, personStore.getSnapshot);

  return (
    <main className="console">
      <SectionHead title="People" count={people.length} />
      {people.length === 0 ? (
        <EmptyState
          title="No people yet"
          hint="A person can be linked to events, exchanges, and transactions — the shared thread across activities."
        />
      ) : (
        <ul className="card-list">
          {people.map((person) => (
            <li key={person.id} className="card">
              <header className="card-head">
                <div className="card-heading">
                  <h3 className="card-title">{person.fields.displayName}</h3>
                  <p
                    className={
                      person.fields.description ? "card-purpose" : "card-purpose is-empty"
                    }
                  >
                    {person.fields.description || NO_DESCRIPTION}
                  </p>
                </div>
              </header>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
